import APP from '../../../main.js'
import InvestmentAggregation from './InvestmentAggregation.js'

class IssueAggregation extends InvestmentAggregation {
  compressIrs(){
    // Ensure investmentreturns have been loaded
    if (! this.investments.some((inv) => inv.investment_returns.length > 0)){
      this.getInvestmentReturns()
    }
    
    super.compressIrs()
  }
  get is_minor(){
    return true
  }
  get type(){
    return 'IssueAggregationInvestment'
  }
  get mostRecentInvestment(){
    return this.investments.find(inv => inv.date_primary === this.date_primary)||{}
  }
  get stored_is_closed(){
    return this.investments.every(inv => inv.stored_is_closed)
  }
  get rpct_primary(){
    let array = this.investments.map((inv) => {
      return [
        inv.rpct_primary||0,
        (Math.abs(inv.value_primary||0) + Math.abs((inv.value_primary||0)-(inv.ret_primary||0)))/2
      ]
    })
    return this.weighValues(array)
  }
  get issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.issue_id)
  }
  get stored_rpct_ytd(){
    let array = this.investments.map((inv) => {
      return [
        inv.stored_rpct_ytd||0,
        (Math.abs(inv.stored_value||0) + Math.abs((inv.stored_value||0)-(inv.stored_ret_ytd||0)))/2
      ]
    })
    return this.weighValues(array)
  }
  get stored_rpct_mtd(){
    let array = this.investments.map((inv) => {
      return [
        inv.stored_rpct_mtd||0,
        (Math.abs(inv.stored_value||0) + Math.abs((inv.stored_value||0)-(inv.stored_ret_mtd||0)))/2
      ]
    })
    return this.weighValues(array)
  }
  get stored_rpct_total(){
    let array = this.investments.map((inv) => {
      return [
        inv.stored_rpct_total||0,
        inv.stored_avg_value||0,
      ]
    })
    return this.weighValues(array)
  }
  get stored_volatility(){
    let array = this.investments.map((inv) => {
      return [
        inv.stored_volatility||0,
        inv.stored_avg_value||0,
      ]
    })
    return this.weighValues(array)
  }
  get stored_annual_return(){
    let array = this.investments.map((inv) => {
      return [
        inv.stored_annual_return||0,
        inv.stored_avg_value||0,
      ]
    })
    return this.weighValues(array)
  }
  weighValues(array){
    // [[value, weight],...]
    var sum_v = 0
    var sum_w = 0
    array.forEach((arr)=>{
      sum_v += arr[0]*arr[1]
      sum_w += arr[1]
    })
    return sum_v / sum_w
  }
  firstOfInvestments(key){
    return (this.investments.find(inv => inv)||{})[key]
  }
  sumOfInvestments(key){
    return this.investments.reduce((sum, inv)=> sum+(Number(inv[key])||0), 0)
  }

  // Will only sum up the value once pr. entity. Used to sum up commitments which are shown 
  sumOfInvestmentsPrEntityId(key){
    return this.investments.reduce((acc, inv) => {
      if (!acc.seen.has(inv.entity_id)) {
        acc.sum += Number(inv[key]) || 0;
        acc.seen.add(inv.entity_id);
      }
      return acc;
    }, { sum: 0, seen: new Set() }).sum;
  }
  dateOfInvestments(key, fun){
    let array = this.investments.map(inv => [new Date(inv[key]).getTime(), inv[key]]).filter(ar => ar[0]&&ar[1])
    let maximum = Math[fun](...array.map(arr => arr[0]))
    let found = array.find(arr => arr[0] === maximum)
    return found[1]
  }
  maxOfInvestments(key){
    return Math.max(...this.investments.map(inv => inv[key]).filter(v => v))
  }
  minOfInvestments(key){
    return Math.min(...this.investments.map(inv => inv[key]).filter(v => v))
  }
}

[
  'crncy',
  'issue_id',
  'name',
  'asset_class',
  'reporting_asset_class',
  'start_date_primary',
  'end_date_primary',
  'asset_class_group_id',
  'asset_class_name',
  'bm_weights_primary'
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.firstOfInvestments(key)}
  })
});

[
  'ir_destroyed_at',
  'ir_updated_at',
  'updated_at',
  'date_primary',
  'price_date_primary',
  'stored_last_date',
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.dateOfInvestments(key, 'max')}
  })
});

[
  'created_at',
  'stored_first_date'
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.dateOfInvestments(key,'min')}
  })
});

[
  'price_primary',
  'price_type_primary',
  'crncyrate_primary',
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.mostRecentInvestment[key]}
  })
});

[
  'holding_primary',
  'intacc_loc_primary',
  'pending_loc_primary',
  'value_primary',
  'pending_primary',
  'intacc_primary',
  'clean_value_stored_primary',
  'ret_primary',
  'refund_primary',
  'buy_primary',
  'sell_primary',
  'income_primary',
  'previous_value_primary',
  'pending_change_primary',
  'stored_value',
  'stored_avg_value',
  'stored_previous_value_mtd',
  'stored_previous_value_ytd',
  'stored_ret_ytd',
  'stored_ret_mtd',
  'stored_ret_total',
  'stored_increment_mtd',
  'stored_increment_ytd',
  // Odd result on stored_count, if the investments overlap, days count wil double
  'stored_count',
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.sumOfInvestments(key)}
  })
});

[
'commitment_primary',
'commitment_called_primary'
].forEach((key) => {
  Object.defineProperty(IssueAggregation.prototype, key, {
    get(){return this.sumOfInvestmentsPrEntityId(key)}
  })
});


export default IssueAggregation
